import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import Util from '../Util'
import VuexPersistence from 'vuex-persistedstate'

const vuexLocal = new VuexPersistence({
    storage: window.localStorage
})

Vue.use(Vuex)

export default new Vuex.Store({
    plugins: [vuexLocal],
    state: {
        userInfo: {
            userType: null, // 0 管理员 1 操作员 100 超级管理员
            name: ''
        },
        platDeviceId:"",//操作员登录时选择的设备编号
        showMenu: true,//菜单栏显示则为true
        fullscreenLoading:false,//loading
        version: "1.0.0"//版本号
    },
    mutations: {
        setParam(state, payload) {
            for (let i in payload) {
                state[i] = payload[i]
            }
        }
    },
    actions: {
        async getNotification({
            commit
        }) {
            const ajaxURL = `${Util.searchURL}/Verfy/GetNotifyInfo`
            const res = await axios.get(ajaxURL)
            if (res.data.code == 200) {
                commit('setParam', {
                    notificationList: res.data.data
                })
            }
        }
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js